export class BaseTrackingEvent {
}
//# sourceMappingURL=BaseTrackingEvent.js.map